import React, { useRef, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import axios from "axios";
import {
  FormikForm,
  Section,
  AgGridDataTable,
  TonnageDisclaimer,
  Breadcrumbs,
  ProgressComponent,
} from "../../../shared";
import * as yup from "yup";
import urlParameterHelper from "../../../../utilities/urlParameters";

export default function TannerReportPublic(props) {
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const history = useHistory();
  const formRef = useRef();
  const agGridRef1 = useRef();
  const [rowData1, setRowData1] = useState([]);
  const [columnDefs1, setColumnDefs1] = useState([
    { headerName: "", field: "" },
  ]);
  const agGridRef2 = useRef();
  const [rowData2, setRowData2] = useState([]);
  const [columnDefs2, setColumnDefs2] = useState([
    { headerName: "", field: "" },
  ]);
  //facility report
  const [facilityProgressPercentage, setFacilityProgressPercentage] =
    useState(0);
  const [facilityProgressPercentage2, setFacilityProgressPercentage2] =
    useState(0);
  const [facilityIsLoading, setFacilityIsLoading] = useState(false);
  const [facilityValue, setFacilityValue] = useState(
    Math.round(Math.random() * (44 - 20)) + 20
  );
  const [facilityStop, setFacilityStop] = useState(false);

  //tonnage report
  const [tonnageProgressPercentage, setTonnageProgressPercentage] = useState(0);
  const [tonnageProgressPercentage2, setTonnageProgressPercentage2] =
    useState(0);
  const [tonnageIsLoading, setTonnageIsLoading] = useState(false);
  const [tonnageValue, setTonnageValue] = useState(
    Math.round(Math.random() * (44 - 20)) + 20
  );
  const [tonnageStop, setTonnageStop] = useState(false);
  const [source, setSource] = useState(axios.CancelToken.source());
  history.listen(() => {
    cancelCall();
  });
  const cancelCall = () => {
    source.cancel();
    setSource(axios.CancelToken.source());
  };
  const agGridRef3 = useRef();
  const backToUrl = "/reports";
  const pageTitle = "Tanner Report";
  const initialFormValues = {
    shipYear: params && params.shipYear ? params.shipYear : "",
  };
  const apiEndpoint1 = "/api/v1/hwts/search/tannerreport/facilities";
  const apiEndpoint2 = "/api/v1/hwts/search/tannerreport/tonnage";
  const [api1IsFetching, setapi1IsFetching] = useState(false);
  const [api2IsFetching, setapi2IsFetching] = useState(false);

  const schema = yup.object({
    shipYear: yup.string().required("Ship Year is required."),
  });
  const formConfig = [
    {
      name: "shipYear",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "Select a Ship Year",
        placeholder: "Select a Year",
        type: "prevYears",
      },
    },
  ];

  const setAgGrid1 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let colDef = Object.keys(columnsArr).map((col) => {
      colDefArr.push({
        headerName: col.replace(/_/g, " "),
        field: col,
        sortable: true,
      });
    });

    setColumnDefs1(colDefArr);
    setRowData1(data);
  };
  const setAgGrid2 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    let colDef = Object.keys(columnsArr).map((col) => {
      colDefArr.push({
        headerName: col.replace(/_/g, " "),
        field: col,
        sortable: true,
      });
    });

    setColumnDefs2(colDefArr);
    setRowData2(data);
  };

  const search = (formData, formik) => {
    const qs = urlParameterHelper.stringify(formData);
    window.history.replaceState(null, 'Hazardous Waste Tracking System', `${location.pathname}?${qs}`);

    agGridRef1.current.api.showLoadingOverlay();
    agGridRef2.current.api.showLoadingOverlay();
    setFacilityIsLoading(true); // calling the progress bar
    setTonnageIsLoading(true); // calling the progress bar
    let value = 100;
    let value2 = 100;
    axios
      .get(`${apiEndpoint1}?${qs}`, {
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (percentCompleted > 90) {
            setFacilityProgressPercentage2(value >= 100 ? value - 1 : value++);
            setFacilityStop(true);
          }
        },
      })
      .then((res) => {
        setFacilityStop(false); // stopping progress count
        if (res.data.length === 0) {
          setColumnDefs1([{ headerName: "", field: "" }]);
          setRowData1([]);

          agGridRef1.current.api.showNoRowsOverlay();
        } else {
          setAgGrid1(res.data);
          agGridRef1.current.api.hideOverlay();
        }
        //agGridRef1.current.columnApi.autoSizeColumns(allColumnIds, false);
        agGridRef1.current.api.sizeColumnsToFit();
        agGridRef1.current.columnApi.autoSizeAllColumns();
        setapi1IsFetching(false);
        if (api1IsFetching === false && api2IsFetching === false)
          formik.setSubmitting(false);
      })
      .then(() => {
        setFacilityIsLoading(false);
      })
      .catch((err) => {
        setFacilityIsLoading(false);

        if (err.response && err.response.status === 400) {
          let requiredError = err.response.data.error;
          let message = err.response.data.message;

          let requiredFieldsArr = err.response.data.required;
          let requiredFields = new Object();

          requiredFieldsArr.map((field) => {
            requiredFields = {
              ...requiredFields,
              [field]: requiredError == 2 ? message : `${field} is required.`,
            };
          });

          formik.setErrors(requiredFields);
          setapi1IsFetching(false);
          if (api1IsFetching === false && api2IsFetching === false)
            formik.setSubmitting(false);
        }
        setColumnDefs1([{ headerName: "", field: "" }]);
        setRowData1([]);

        agGridRef1.current.api.showNoRowsOverlay();
      });
    axios
      .get(`${apiEndpoint2}?${qs}`, {
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          if (percentCompleted > 90) {
            setTonnageProgressPercentage2(value >= 100 ? value - 1 : value++);
            setTonnageStop(true);
          }
        },
      })
      .then((res) => {
        setTonnageStop(false); // stopping progress count
        if (res.data.length === 0) {
          setColumnDefs2([{ headerName: "", field: "" }]);
          setRowData2([]);

          agGridRef2.current.api.showNoRowsOverlay();
        } else {
          setAgGrid2(res.data);
          // agGridRef2.current.api.hideOverlay();
        }

        agGridRef2.current.api.sizeColumnsToFit();
        setapi2IsFetching(false);
        if (api1IsFetching === false && api2IsFetching === false)
          formik.setSubmitting(false);
      })
      .then(() => {
        setTonnageIsLoading(false);
      })
      .catch((err) => {
        setTonnageIsLoading(false);
        if (err.response && err.response.status === 400) {
          let requiredError = err.response.data.error;
          let message = err.response.data.message;

          let requiredFieldsArr = err.response.data.required;
          let requiredFields = new Object();

          requiredFieldsArr.map((field) => {
            requiredFields = {
              ...requiredFields,
              [field]: requiredError == 2 ? message : `${field} is required.`,
            };
          });

          formik.setErrors(requiredFields);
        }
        setColumnDefs2([{ headerName: "", field: "" }]);
        setRowData2([]);

        agGridRef2.current.api.showNoRowsOverlay();
        setapi2IsFetching(false);
        if (api1IsFetching === false && api2IsFetching === false)
          formik.setSubmitting(false);
      });
  };

  const onSubmit = (formData, formik) => {
    search(formData, formik);
  };

  useEffect(() => {
    if (searchOnInit) {
      setTimeout(() => formRef.current.submitForm());
    }
  }, [searchOnInit]);

  return (
    <React.Fragment>
      <Section title="Tanner Report" type={"standout"} />
      <div id="page-container" className="container" style={{ position: "relative" }}>
        <Breadcrumbs
          breadcrumbs={[
            { name: "HWTS Reports", url: "/reports", active: false },
            { name: "Tanner Report", url: "", active: true },
          ]}
        />
        <FormikForm
          initialFormValues={initialFormValues}
          schema={schema}
          formConfig={formConfig}
          onSubmit={onSubmit}
          cancelCall={cancelCall}
          formRef={formRef}
        />
        <h3 style={{ textAlign: "center" }}>Facilities</h3>

        <ProgressComponent
          percent={facilityProgressPercentage}
          setProgressPercentage={setFacilityProgressPercentage}
          percent2={facilityProgressPercentage2}
          grid={true}
          isLoading={facilityIsLoading}
          value={facilityValue}
          stop={facilityStop}
        />

        <AgGridDataTable
          agGridRef={agGridRef1}
          columnDefs={columnDefs1}
          rowData={rowData1}
          initialPageSize={50}
          pageTitle="Tanner_Facilities"
        />
        <h3 style={{ textAlign: "center" }}>Tonnage</h3>

        <ProgressComponent
          percent={tonnageProgressPercentage}
          setProgressPercentage={setTonnageProgressPercentage}
          percent2={tonnageProgressPercentage2}
          grid={true}
          isLoading={tonnageIsLoading}
          value={tonnageValue}
          stop={tonnageStop}
        />

        <AgGridDataTable
          agGridRef={agGridRef2}
          columnDefs={columnDefs2}
          rowData={rowData2}
          initialPageSize={50}
          pageTitle="Tanner_Tonnage"
        />
        <div className="m-b-md"></div>
        <TonnageDisclaimer />
      </div>
    </React.Fragment>
  );
}
